
export class Message {
        id_mess:any;
        contenue_mess:any;
	    im_dest:any;
        nom_dest : any;
        tel_dest:any;
        mail_dest:any;
        prenom_dest:any;
        direction_g : any;
        direction:any;
        service : any;
        etat_mess : any;
       // date2:any;

         date_mess:Date;
       // etat_agent:any;
       
       
    constructor(id_mess:any){
           
    }
}
